import { Component } from "@angular/core";

@Component({
    selector:'app-vehicles',
    template:'<router-outlet></router-outlet>'
})
export class VehiclesComponent{

}